<template>
  <div>
    <div v-if="haveAbroadService">
      <div v-if="this.lesson_status == 1">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="时间规划" name="first">
            <div style="display: flex;width: 100%">
              <div style="width: 30%;border: 1px solid #e8e6e5;padding: 10px">
                <tab_sixteen></tab_sixteen>
              </div>
              <div style="width: 70%;border: 1px solid #e8e6e5;border-left: none">
                <div style="border-bottom: 1px solid #e8e6e5;padding-left: 2rem;padding-right: 2rem">
                  <tab_fifteen></tab_fifteen>
                </div>
                <div style="border-bottom: 1px solid #e8e6e5;padding-left: 2rem;padding-right: 2rem">
                  <tab_seventeen></tab_seventeen>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="three" lazy>
            <span slot="label">个人信息
            </span>
            <tab_three flag="three"></tab_three>
          </el-tab-pane>
          <el-tab-pane name="four" lazy>
            <span slot="label">申请材料
              <el-tooltip content="先填写'个人信息'，系统会根据个人信息的内容自动生成需要上传的申请材料">
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            <tab_four flag="four"></tab_four>
          </el-tab-pane>
          <el-tab-pane label="选校" name="second" lazy>
            <tab_second flag="second"></tab_second>
          </el-tab-pane>

          <el-tab-pane label="博士套磁" name="second_two" v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
            this.bindInfo.apply_academic_degree.includes('申请博士') ||
            this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
            this.bindInfo.apply_academic_degree.includes('研究型硕士学位')">
            <tab_second_two></tab_second_two>
          </el-tab-pane>
          <el-tab-pane label="PhD动机" name="second_two2" v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
            this.bindInfo.apply_academic_degree.includes('申请博士') ||
            this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
            this.bindInfo.apply_academic_degree.includes('研究型硕士学位')">
            <tab_phd_1></tab_phd_1>
          </el-tab-pane>
          <el-tab-pane label="SOP" name="second_two3" v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
            this.bindInfo.apply_academic_degree.includes('申请博士') ||
            this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
            this.bindInfo.apply_academic_degree.includes('研究型硕士学位')">
            <tab_phd_2></tab_phd_2>
          </el-tab-pane>
          <el-tab-pane label="奖学金" name="second_two4" v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
            this.bindInfo.apply_academic_degree.includes('申请博士') ||
            this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
            this.bindInfo.apply_academic_degree.includes('研究型硕士学位')">
            <tab_phd_3></tab_phd_3>
          </el-tab-pane>
          <!-- <el-tab-pane label="实习企业" name="3-2">
            <tab_seven_three></tab_seven_three>
          </el-tab-pane> -->
          <el-tab-pane name="eleven" lazy>
            <span slot="label">CV</span>
            <el-card class="box-card" style="width: 100%; margin: 0 auto">
              <tab_eleven></tab_eleven>
            </el-card>
          </el-tab-pane>
          <el-tab-pane name="six" lazy>
            <span slot="label">PS</span>
            <tab_seven flag="seven"></tab_seven>
          </el-tab-pane>
          <el-tab-pane name="seven" lazy>
            <span slot="label">RL
            </span>
            <tab_six flag="six"></tab_six>
          </el-tab-pane>
          <el-tab-pane label="文书" name="five" lazy>
            <tab_five flag="five"></tab_five>
          </el-tab-pane>
          <el-tab-pane label="签证" name="11">
            <el-card class="box-card" style="width: 100%; margin: 0 auto">
              <tab_twelve></tab_twelve>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="this.lesson_status == 2" style="color: red; width: 100%; text-align: center">
        留学服务已冻结<span v-if="this.lesson_status == 5">退费</span>
      </div>
      <div v-if="this.lesson_status == 3" style="color: red; width: 100%; text-align: center">
        留学服务已结案
      </div>
    </div>
    <div v-else style="color: red; width: 100%; text-align: center">
      当前账户未购买留学申请服务，请核验手机号码或联系顾问
    </div>
  </div>
</template>

<script>
import tab_first from "../mycenter_studyabroad/component/tab_first";

import tab_second from "../mycenter_studyabroad/component/tab_second";
import tab_second_two from "../mycenter_studyabroad/component/tab_second_two";
import tab_three from "../mycenter_studyabroad/component/tab_three";
import tab_four from "../mycenter_studyabroad/component/tab_four";
import tab_five from "../mycenter_studyabroad/component/tab_five";
import tab_six from "../mycenter_studyabroad/component/tab_six";
import tab_seven from "../mycenter_studyabroad/component/tab_seven";
import tab_eleven from "../mycenter_studyabroad/component/tab_eleven";
import tab_twelve from "../mycenter_studyabroad/component/tab_twelve";
import tab_fifteen from "../mycenter_studyabroad/component/tab_fifteen";
import tab_sixteen from "../mycenter_studyabroad/component/tab_sixteen";
import tab_seventeen from "../mycenter_studyabroad/component/tab_seventeen";
import tab_seven_three from "../mycenter_studyabroad/component/tab_seven_three";
import tab_phd_1 from "../mycenter_studyabroad/component/tab_phd_1.vue";
import tab_phd_2 from "../mycenter_studyabroad/component/tab_phd_2.vue";
import tab_phd_3 from "../mycenter_studyabroad/component/tab_phd_3.vue";

import { checkHaveAbroadService } from "@/api/mycenter_studyabroad";
import { checkUserEmail } from "../../api/mycenter_studyabroad";
import Tab_phd_1 from "../mycenter_studyabroad/component/tab_phd_1.vue";
export default {
  name: "App",
  components: {
    tab_phd_1,
    tab_phd_2,
    tab_phd_3,
    tab_first,
    tab_seven_three,
    tab_second,
    tab_second_two,
    tab_three,
    tab_four,
    tab_five,
    tab_six,
    tab_seven,
    tab_eleven,
    tab_twelve,
    tab_fifteen,
    tab_sixteen,
    tab_seventeen,
  },
  data() {
    return {
      activeName: "first",
      loading: true,
      lesson_status: null,
      refund: null,
      haveAbroadService: true,
      bindInfo: null
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.t) {
      this.activeName = this.$route.query.t
    } else {
      this.activeName = 'first'
    }
    this.getUserBindInfo()
  },
  created() {
    checkUserEmail()
      .then((response) => {
        if (response.data) {
          this.$alert(response.data, '提示', {
            type: 'warning'
          });
        }
      })
    // this.bindInfo = this.$store.state.userAbroad.userAbroadData;
    this.$bus.on("change-abroad-tab", (val) => {
      this.activeName = val;
    });
    checkHaveAbroadService()
      .then((response) => {
        this.loading = false;
        this.haveAbroadService = response.data.status
        this.lesson_status = response.data.lesson_status
        this.refund = response.data.refund
        // console.log('测试'
        // console.log(response.data)
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  watch: {
    activeName: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$bus.emit("abroad_tabs_changes", newVal);
        }
      },
    },
  },
  methods: {
    getUserBindInfo() {
      this.$store
        .dispatch(
          "userAbroad/geUserAbroadData",
          parseInt(this.$route.query.userId)
        )
        .then(() => {
          this.bindInfo = this.$store.state.userAbroad.userAbroadData;
          this.lessonOpenInfo = this.$store.state.userAbroad.lessonOpenInfo;
        })
    },
    handleClick(tab) {
      this.$router.push({ query: { ...this.$route.query, t: tab.name } })
    },
    checkCVHelpe() {
      window.open(
        "https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/other_file/D808898914356632.pdf",
        "_blank"
      );
    },
    checkRLHelp() {
      window.open(
        "https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/other_file/D808899682743388.pdf",
        "_blank"
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/studyabroad.vue